// components/notifications/NotificationBell.tsx
//
// Public mount point used in TopNavBar (desktop) and MobileNavigation
// (mobile header). Wraps the dropdown so navs don't import internals.

'use client'

import { NotificationDropdown } from './NotificationDropdown'

export function NotificationBell() {
  return <NotificationDropdown />
}
